import { defineStore } from "pinia";
import { handleError } from "../helpers/helpers";
import RepositoryFactory from "@/repositories/apiGateWay/repositoryFactory";
const apiGatewayRepository = RepositoryFactory.get("apiGateway");
import { API_RESPONSE_SUCCESS, SUCCESS_CODE } from "@/data/constants";
import ApplicationError from "@/helpers/applicationError";

export const useResetPasswordStore = defineStore("resetPassword", {
    id: "resetPassword",
    state() {
        return {
            isLoading: false,
            resetPasswordForm: {
                email: "",
            },
            errorMessage: null
        };
    },
    getters: {
        getResetPasswordData(state) {
            return state.resetPasswordForm;
        },
    },
    actions: {
        async resetPassword() {
            try {
                this.isLoading = true;
                //Reset error message
                this.errorMessage = null;

                let passwordFormData = this.getResetPasswordData;
                const response = await apiGatewayRepository.resetPassword(
                    passwordFormData.email,
                );
                this.isLoading = false;
                return response.success === API_RESPONSE_SUCCESS && response.code === SUCCESS_CODE;

            } catch (e) {
                this.isLoading = false;

                const errorMessage = await handleError(e);
                if (errorMessage != null) {
                    this.errorMessage = errorMessage;
                }
            }
        },
    },
});
